<p-splitButton [label]="$any(currentStepName$ | async)" appendTo="body" [size]="size" [model]="menuItems()"></p-splitButton>